export const FEED = 'FEED';
export const RIGHT = 'RIGHT';
